import React, { Component } from 'react';
import Lock from '../../../../../Images/Daikin_Images/icon/Lock1.png';
import Unlock from '../../../../../Images/Daikin_Images/icon/Lock2.png';

export default class DoorLock_Lock_Unlock extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div id='doorlock_lock_unlock'>
				<div>
					<img src={this.props.lock_unlock == 'close' ? Lock : Unlock} style={this.props.style} />
				</div>
			</div>
		)
	}
}